"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var getBlockName = function (blockOrFilename) {
    return blockOrFilename.split('/').pop().split('.').shift();
};
// Takes a `block` string and an `allStyles` object and iterates
// through all of the values in `allStyles`, adding a `label`
// key to them so emotion labels the classes nicely. If a `label`
// is already specified on a value then it'll take precedence.
var labelStyles = function (block, allStyles) {
    block = getBlockName(block);
    var mapped = lodash_1.mapValues(allStyles, function (styles, name) {
        var label = name === 'root' ? block : block + "__" + name;
        if (typeof styles === 'function') {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return [
                    {
                        label: label,
                    },
                    styles.apply(void 0, __spread(args)),
                ];
            };
        }
        return [
            {
                label: label,
            },
            styles,
        ];
    });
    return mapped;
};
exports.default = labelStyles;
